import { Injectable, OnInit, Pipe, PipeTransform} from '@angular/core';
import { TranslateService } from './translate.service';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'translate',
})
export class TranslatePipe implements PipeTransform {

constructor(
  public translateService:TranslateService
  ) {
    
  }
 


  transform(key: any,slug:any,componentName:any,group:any=null): any {
    return this.translateService.GetResourcesP(slug,key,group,componentName);


   
  }

}
